import { useMemo } from 'react';
import {
  TimeSignalAnalyticsQuery,
  TimeSignalDimensionType,
  useTimeSignalAnalyticsQuery
} from 'graphql/types';
import { useGetPreviousPeriod } from './useGetPreviousPeriod';

export const useGetPreviousAnalyticsData = (
  dimension: TimeSignalDimensionType
): {
  data: TimeSignalAnalyticsQuery | undefined;
  loading: boolean;
} => {
  const { prevStartDate, prevEndDate } = useGetPreviousPeriod();
  const { loading, data } = useTimeSignalAnalyticsQuery({
    variables: {
      input: {
        dimension,
        filter: {
          fromDate: prevStartDate,
          toDate: prevEndDate
        }
      }
    }
  });
  return useMemo(
    () => ({
      data,
      loading
    }),
    [data, loading]
  );
};
